import request from "@/utils/request";

// 列表(主数据列表)
export function listFixedAssetDataApi(data) {
  return request({
    url: "web/fixedAsset/listData",
    method: "post",
    data,
  });
}
// 导出
export function exportFixedAssetDataApi(data) {
  return request({
    url: "web/fixedAsset/exportData",
    method: "post",
    data,
  });
}
// 初始化
export function initFixedAssetApi(data) {
  return request({
    url: "web/fixedAsset/init",
    method: "post",
    data,
  });
}
// 保存
export function saveFixedAssetApi(data) {
  return request({
    url: "web/fixedAsset/save",
    method: "post",
    data,
  });
}
// 修改
export function updateFixedAssetApi(data) {
  return request({
    url: "web/fixedAsset/update",
    method: "post",
    data,
  });
}
// 作废
export function deleteFixedAssetApi(data) {
  return request({
    url: "web/fixedAsset/delete",
    method: "post",
    data,
  });
}
// 调拨
export function allotFixedAssetApi(data) {
  return request({
    url: "web/fixedAsset/allot",
    method: "post",
    data,
  });
}
// 报废|遗失
export function breakageFixedAssetApi(data) {
  return request({
    url: "web/fixedAsset/breakage",
    method: "post",
    data,
  });
}
// 借用
export function borrowFixedAssetApi(data) {
  return request({
    url: "web/fixedAsset/borrow",
    method: "post",
    data,
  });
}
// 转移
export function transferFixedAssetManagerApi(data) {
  return request({
    url: "web/fixedAsset/transfer",
    method: "post",
    data,
  });
}
// 获取固定资产管理员选项数据
export function loadSelectManagerDataApi(data) {
  return request({
    url: "web/fixedAsset/loadSelectManagerData",
    method: "post",
    data,
  });
}
// 获取管理人员所管理的固定资产清单
export function loadManageFixedAssetDataApi(data) {
  return request({
    url: "web/fixedAsset/loadManageFixedAssetData",
    method: "post",
    data,
  });
}
// 分页查询日志记录
export function listFixedAssetLogByPageApi(data) {
  return request({
    url: "web/fixedAssetLog/listData",
    method: "post",
    data,
  });
}
// 分页查询借用记录
export function listFixedAssetBorrowByPageApi(data) {
  return request({
    url: "web/fixedAssetBorrow/listData",
    method: "post",
    data,
  });
}
// 归还借用
export function returnFixedAssetBorrowApi(data) {
  return request({
    url: "web/fixedAssetBorrow/returnBack",
    method: "post",
    data,
  });
}
// 撤销借用
export function revokeFixedAssetBorrowApi(data) {
  return request({
    url: "web/fixedAssetBorrow/revoke",
    method: "post",
    data,
  });
}
